import { cardStatementService } from "../services/cardStatement.service";
import { show as showAlert } from "../../Notifications/actions/alert.actions";
import { message } from "../../../constants/app.constants";
import { cardStatementConstants, nameSpace } from "../constants/cardStatement.constants";
import { createRequestBody } from "../factories/cardStatements.factory";
import { appUtils } from "../../../utils/app.utils";
import { store } from "../../../store";

export const searchCardStatement = (requestParams) => {
    return async (dispatch) => {
        let params = null;
        const requestObject = createRequestBody(requestParams);

        const issuerData = store.getState().currentUser.response;
        const issuerDomainCode = issuerData && issuerData.domainCode;
       
        const customiseHeader = {};
        if (issuerDomainCode !== null || issuerDomainCode !== undefined) {
            customiseHeader["X-Interswitch-Authorization-Domain"] = issuerDomainCode;
        }
        //CHECK IF IT IS NOT ISW AND SEND THE RIGHT QUERY PARAMS.
        if (issuerData && issuerData.domainCode !== "ISW") {
            params = {
                reportType: requestObject.reportType,
            };
        } else {
            params = {
                domainCode: requestObject.domainCode,
                reportType: requestObject.reportType,
            };
        }

        dispatch(request(requestParams));
        try {
            const response = issuerData && issuerData.domainCode !== "ISW" ? await cardStatementService.getNewCardStatement(params, requestObject.requestParams, customiseHeader) : await cardStatementService.getNewCardStatementAdmin(params, requestObject.requestParams, customiseHeader);

            response && dispatch(success(response));
        } catch (error) {
            dispatch(failure(error));
            dispatch(showAlert("danger", "Failed to get card statement", error ? error.message : message.GENERIC_ERROR));
        }
    };

    function request(request) {
        return {
            type: cardStatementConstants[`GET_${nameSpace}_REQUEST`],
            request,
        };
    }
    function success(response) {
        return {
            type: cardStatementConstants[`GET_${nameSpace}_SUCCESS`],
            response,
        };
    }
    function failure(error) {
        return { type: cardStatementConstants[`GET_${nameSpace}_FAILURE`], error };
    }
};

export const pdfDownloadCardStatement = (requestParams) => {
    return async (dispatch) => {
        let params = null;
        const requestObject = createRequestBody(requestParams);

        const issuerData = store.getState().currentUser.response;
        const issuerDomainCode = issuerData && issuerData.domainCode;
        
        const customiseHeader = {};
        if (issuerDomainCode !== null || issuerDomainCode !== undefined) {
            customiseHeader["X-Interswitch-Authorization-Domain"] = issuerDomainCode;
        }
        if (issuerData && issuerData.domainCode !== "ISW") {
            params = {
                fileType: requestObject.fileType,
            };
        } else {
            params = {
                domainCode: requestObject && requestObject.domainCode ? requestObject.domainCode : "",
                fileType: requestObject.fileType,
            };
        }
        dispatch(request(requestParams));
        try {
            const response = issuerData && issuerData.domainCode !== "ISW" ? await cardStatementService.getNewCardStatement(params, requestObject.requestParams, customiseHeader) : await cardStatementService.getNewCardStatementAdmin(params, requestObject.requestParams, customiseHeader);

            if (response) {
                dispatch(success(response));

                if (requestObject.fileType === "CSV") {
                    appUtils.csvDownloadFile(response);
                } else {
                    appUtils.pdfDownloadFile(response);
                }
            }
        } catch (error) {
            dispatch(failure(error));
            dispatch(showAlert("danger", "Failed to download card statement", error ? error.message : message.GENERIC_ERROR));
        }
    };

    function request(request) {
        return {
            type: `DOWNLOADPDF_${nameSpace}_REQUEST`,
            request,
        };
    }
    function success(response) {
        return {
            type: `DOWNLOADPDF_${nameSpace}_SUCCESS`,
            response,
        };
    }
    function failure(error) {
        return { type: `DOWNLOADPDF_${nameSpace}_FAILURE`, error };
    }
};

export const downloadCardStatement = (requestParams) => {
    return async (dispatch) => {
        let params = null;
        const requestObject = createRequestBody(requestParams);

        const issuerData = store.getState().currentUser.response;
        const issuerDomainCode = issuerData && issuerData.domainCode;
       
        const customiseHeader = {};
        if (issuerDomainCode !== null || issuerDomainCode !== undefined) {
            customiseHeader["X-Interswitch-Authorization-Domain"] = issuerDomainCode;
        }
        if (issuerData && issuerData.domainCode !== "ISW") {
            params = {
                fileType: requestObject.fileType,
            };
        } else {
            params = {
                domainCode: requestObject && requestObject.domainCode ? requestObject.domainCode : "",
                fileType: requestObject.fileType,
            };
        }
        dispatch(request(requestParams));
        try {
            const response = issuerData && issuerData.domainCode !== "ISW" ? await cardStatementService.getNewCardStatement(params, requestObject.requestParams, customiseHeader) : await cardStatementService.getNewCardStatementAdmin(params, requestObject.requestParams, customiseHeader);

            if (response) {
                dispatch(success(response));

                if (requestObject.fileType === "CSV") {
                    appUtils.csvDownloadFile(response);
                } else {
                    appUtils.pdfDownloadFile(response);
                }
            }
        } catch (error) {
            dispatch(failure(error));
            dispatch(showAlert("danger", "Failed to download card statement", error ? error.message : message.GENERIC_ERROR));
        }
    };

    function request(request) {
        return {
            type: `DOWNLOAD_${nameSpace}_REQUEST`,
            request,
        };
    }
    function success(response) {
        return {
            type: `DOWNLOAD_${nameSpace}_SUCCESS`,
            response,
        };
    }
    function failure(error) {
        return { type: `DOWNLOAD_${nameSpace}_FAILURE`, error };
    }
};

export const resetStatements = () => {
    return { type: cardStatementConstants[`GET_${nameSpace}_RESET`] };
};

export const resetStatementDownload = () => {
    return { type: `DOWNLOAD_${nameSpace}_RESET` };
};

export const pdfResetStatementDownload = () => {
    return { type: `DOWNLOADPDF_${nameSpace}_RESET` };
};
